import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RyderButton from '../RyderButton';
import StripePaymentForm from '../StripePaymentForm';
import { Elements, StripeProvider } from 'react-stripe-elements';
import moment from 'moment';
import { formatMoney } from '../../utils/helper';
import config from '../../config';
import {
  ResultsContainer,
  Title,
  ResultItem,
  Label
} from './styledComponents';

/**
 * Results Component documentation
 * @property       {bool} confirmTotalOwed A boolean to determine if confirmation of total amount is displayed
 * @property       {func} onBack Function to handle Back event
 * @property       {func} onClickPay Function to handle Back event
 * @property       {object} invoice Object to store data of invoice
 * @property       {string} accountNumber String to store account number to be sent to pay-invoice endpoint
 *
 */

class Results extends Component {
  state = {
    showPayFull: true,
    backPage: 'search',
  };
  componentDidUpdate() {
    const {
      confirmTotalOwed,
    } = this.props;
    const {
      showPayFull,
    } = this.state;
    if(!confirmTotalOwed && !showPayFull)
      this.setState({
        showPayFull: true,
      });
  }
  handleBack = (ev) => {
    const {
      onBack,
      invoice,
      accountNumber,
    } = this.props;
    const {
      backPage,
    } = this.state;
    ev.preventDefault();
    onBack(backPage, invoice, accountNumber);
    if(backPage === 'results')
      this.setState({
        backPage: 'search',
      });
  };
  handleClickPay = (ev) => {
    const {
      onClickPay,
      invoice,
      accountNumber,
    } = this.props;
    ev.preventDefault();
    this.setState({
      showPayFull: false,
      backPage: 'results',
    });
    onClickPay('payment', invoice, accountNumber);
  };
  setSearchData = (text, fieldName) => {
    const { searchData } = this.state;
    searchData[fieldName] = text.trimLeft();
    this.setState({ searchData });
    this.validateError();
  };
  render() {
    const {
      confirmTotalOwed,
      invoice,
      onBack,
      accountNumber,
    } = this.props;
    const {
      showPayFull,
    } = this.state;
    return (
      <ResultsContainer>
        <RyderButton
          className="absolute results"
          onClick={this.handleBack}
        >
          Back
        </RyderButton>
        <Title>Your Results</Title>
        <ResultItem className="invoice">
          <Label>Invoice #:</Label>
          {invoice.metadata.invoiceNumber}
        </ResultItem>
        <ResultItem className="invoice-date">
          <Label>Invoice date:</Label>
          {moment(invoice.metadata.invoiceDate).format('MMMM Do, YYYY')}
        </ResultItem>
        <ResultItem className="total">
          <Label>Total amount owed:</Label>
          {formatMoney(invoice.amount_due/100)}
        </ResultItem>
        {
          confirmTotalOwed && <ResultItem className="total">
            <Label>You are paying this amount:</Label>
            {formatMoney(invoice.amount_due/100)}
          </ResultItem>
        }
        {
          showPayFull ? <RyderButton onClick={this.handleClickPay}>Pay in full</RyderButton>
          :
          <StripeProvider apiKey={config.apiKey}>
            <Elements>
              <StripePaymentForm invoice={invoice} onBack={onBack} accountNumber={accountNumber} />
            </Elements>
          </StripeProvider>
        }
      </ResultsContainer>
    );
  }
}

Results.propTypes = {
  onBack: PropTypes.func.isRequired,
  invoice: PropTypes.object.isRequired,
  onClickPay: PropTypes.func,
  accountNumber: PropTypes.string.isRequired,
};

export default Results;



// WEBPACK FOOTER //
// ./src/components/Results/index.js